
import {FirebaseSingleton} from "../helpers/firebaseSingleton"

export default {
    namespaced: true,
    state:{
        firebaseApp:{}
    },
    mutations:{
        setFirebaseApp(state,value){
            state.firebaseApp = value;
        },
    },
    getters: {
        getFirebaseApp:state=>{
            return state.firebaseApp;
        }
    },
    actions:{
        initFirebaseApp:async (context)=>{
            const appFirebase = await FirebaseSingleton.init();
            context.commit('setFirebaseApp', appFirebase);
        }
    }
}